module.exports = __webpack_public_path__ + "static/media/first.888e79ce.png";